import React, { useState } from "react"
import { Modal, ModalBody, ModalFooter, Button } from "react-bootstrap"
import { FormattedMessage } from "react-intl"

type OwnProps = {
    onClickEventCallback: (e) => void
    buttonLabel: Element
    buttonIcon: Element
    buttonClassName: string
    allowedModalMessage: Element
    deniedModalMessage: Element
    allowedPermission: boolean
}



const PermissionProtectedWarningButton = (props: OwnProps) => {
    const [modal, setModal] = useState(<></>)

    const closeModal = () => {
        setModal(<></>)
    }

    const closeAndOnClick = (e) => {
        closeModal()
        props.onClickEventCallback(e)
    }

    const openModal = (event: React.MouseEvent) => {
        event.preventDefault()
        setModal(<Modal show={true} onHide={closeModal} centered size={"lg"}>
            <ModalBody>
                {props.allowedPermission ? props.allowedModalMessage : props.deniedModalMessage}
            </ModalBody>
            <ModalFooter>
                {props.allowedPermission ? <>
                    <Button variant="primary" onClick={(e) => { closeAndOnClick(e) }}>
                        <FormattedMessage
                            id="common.button.customizable_footer_button.yes_label"
                            defaultMessage="Yes"
                        />
                    </Button>
                    <Button variant="secondary" onClick={closeModal}>
                        <FormattedMessage
                            id="common.button.customizable_footer_button.no_label"
                            defaultMessage="No"
                        />
                    </Button>
                </> :
                    <Button variant="secondary" onClick={closeModal}>
                        <FormattedMessage
                            id="common.button.customizable_footer_button.ok_label"
                            defaultMessage="Okay"
                        />
                    </Button>}
            </ModalFooter>
        </Modal>)
    }

    return (<>
        <button onClick={openModal} className={props.buttonClassName}>
            {props.buttonIcon}
            {props.buttonLabel}
        </button>
        {modal}
    </>)



}

export default PermissionProtectedWarningButton


// WEBPACK FOOTER //
// ./src/common/button/PermissionProtectedWarningButton.tsx